import { CommonModule } from '@angular/common';
import { Component, Type } from '@angular/core';
import { FieldType, FormlyFieldConfig, FormlyFieldProps } from '@ngx-formly/core';

export interface AlertProps extends FormlyFieldProps {
  text: string;
  html: string;
  type: string;
}

export interface FormlyAlertFieldConfig extends FormlyFieldConfig<AlertProps> {
  type: 'alert' | Type<AlertComponent>;
}

@Component({
  selector: 'vectronic-formly-alert',
  imports: [CommonModule],
  template: `
    <div class="alert" [ngClass]="'alert-' + (props.type ?? 'info')">
      @if (props.html) {
        <div [innerHTML]="props.html"></div>
      } @else {
        <p>{{ props.text }}</p>
      }
    </div>
  `,
})
export class AlertComponent extends FieldType<FormlyFieldConfig<AlertProps>> {}
